// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O39Q","question":"styles_question__242SD","description":"styles_description__3rXp0"};